import React, { useLayoutEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { haveAuth } from "utils"
import CanceledOrders from "./CanceledOrders"
import PaidOrders from "./PaidOrders"
import PendingOrders from "./PendingOrders"
import OrderHistory from "./OrderHistory"
import NotConfirmedOrders from "./NotConfirmedOrders"
import OrdersSidebar from "./OrdersSidebar"
import OfflineOrders from "./OfflineOrders"
import OrderTopbar from "./OrderTopbar"
import OrdersFilter from "./OrdersFilter"
import ReadyOrders from "./ReadyOrders"
import LateOrders from "./LateOrders"
import PaymentProblematicOrders from "./PaymentProblematicOrders"
import classes from "./index.module.scss"

const showOrdersFilter = {
  temp: false,
  offline: false,
  pending: true,
  paid: true,
  canceled: true,
  delivered: true,
  paymentProblematic: true
}

const Orders = () => {
  const i18n = useTranslation()[1]

  const params = useParams()

  const userAccountInfo =
    useSelector(state => state.userAccountInfo)

  const initalFilterState = {
    limit: 40,
    fromDate: "",
    toDate: "",
    addedBySystem: null,
    branch: null,
    account: null,
    addedByAccount: null,
    isViewed: true,
    deliveryType: "",
    isDispatched: null,
    statusMultiple: ["pending"]
  }

  if (!haveAuth(["viewOtherAccessesOrders"])) {
    initalFilterState.addedByAccount = {
      label: "",
      value: userAccountInfo._id
    }
  }

  const [currentTab, setCurrentTab] = useState("")
  const [openOrderSidebar, setOpenOrderSidebar] = useState(true)
  const [orderCode, setOrderCode] = useState("")
  const [filters, setFilters] = useState(initalFilterState)

  const setInitialTab = () => {
    if (!params) return

    setCurrentTab(
      params.initialTab || "pending"
    )
  }

  useLayoutEffect(() => {
    setInitialTab()
  }, [])

  const showFilter =
    showOrdersFilter[currentTab]

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["container"]}>
      <OrdersSidebar
        setOrderCode={setOrderCode}
        setFilters={setFilters}
        currentTab={currentTab}
        setCurrentTab={setCurrentTab}
        openOrderSidebar={openOrderSidebar}
        setOpenOrderSidebar={setOpenOrderSidebar}
      />

      <OrderTopbar
        setOpenOrderSidebar={setOpenOrderSidebar}
      />

      <div
        className={clsx(
          classes["main"],
          isLtr && classes["main-ltr"]
        )}
      >
        <div className={classes["wrapper"]}>
          {
            showFilter &&
            <OrdersFilter
              filters={filters}
              setFilters={setFilters}
              setOrderCode={setOrderCode}
            />
          }
          {
            currentTab === "pending" &&
            <PendingOrders
              orderCode={orderCode}
              filters={filters}
            />
          }
          {
            currentTab === "paid" &&
            <PaidOrders
              orderCode={orderCode}
              filters={filters}
            />
          }
          {
            currentTab === "canceled" &&
            <CanceledOrders
              orderCode={orderCode}
              filters={filters}
            />
          }
          {
            currentTab === "delivered" &&
            <OrderHistory
              orderCode={orderCode}
              filters={filters}
            />
          }
          {
            currentTab === "paymentProblematic" &&
            <PaymentProblematicOrders
              orderCode={orderCode}
              filters={filters}
            />
          }
          {
            currentTab === "temp" &&
            <NotConfirmedOrders />
          }
          {
            currentTab === "offline" &&
            <OfflineOrders />
          }
          {
            currentTab === "late" &&
            <LateOrders
              orderCode={orderCode}
              filters={filters}
            />
          }
          {
            currentTab === "ready" &&
            <ReadyOrders
              orderCode={orderCode}
              filters={filters}
            />
          }
        </div>
      </div>
    </div>

  )
}

export default Orders